import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import GroupedUsageTable from '../GroupedUsageTable.js';
import { sumEnabledVolume } from '../calculations/balanceCalculations.js';

/**
 * Étape 1 : gisement d'eau grise — douche et lave-linge de l'audit, pré-cochés. L'utilisateur
 * peut décocher des points précis, ou ajouter manuellement une autre source (ex. robinets/hygiène)
 * via le sélecteur de catégorie du tableau.
 */
const SourcesStep = ({ sources, setSources, groups, currentStep, totalSteps, goPrevious, goNext, canAdvance }) => {
  const { building_id } = useParams();
  const total = useMemo(() => sumEnabledVolume(sources), [sources]);
  const hasAuditData = sources.some(it => it.fromAudit);

  return (
    <div className="apv2-step-card">
      <div className="apv2-step-header">
        <div className="apv2-step-header-text">
          <span className="apv2-step-eyebrow">Réutilisation des eaux grises</span>
          <h2 className="apv2-step-heading">Gisement d'eau grise</h2>
        </div>
        <span className="apv2-step-counter">{currentStep + 1} / {totalSteps}</span>
      </div>
      <div className="apv2-step-body">
        <div className="apv2-step-explanation">
          <span className="apv2-step-explanation-icon">💡</span>
          <p className="apv2-step-explanation-text">
            {hasAuditData
              ? "Douches et lave-linge de l'audit sont pré-cochés, avec leur volume annuel réel — la source d'eau grise la moins contaminée, la plus adaptée à une valorisation. Dépliez une catégorie pour décocher des points précis ou ajouter un usage manuel (ex. robinets)."
              : "Aucune douche ni lave-linge détecté dans l'audit de ce bâtiment — dépliez une catégorie ci-dessous pour ajouter vos sources manuellement."}
            {' '}<a href={`/client/${building_id}/usages`} target="_blank" rel="noopener noreferrer">Corriger dans l'audit ↗</a>
          </p>
        </div>

        <GroupedUsageTable items={sources} setItems={setSources} groups={groups} />

        <div className="apv2-summary-cards">
          <div className="apv2-summary-card">
            <span className="apv2-summary-value">{total.toLocaleString('fr-FR', { maximumFractionDigits: 1 })} m³</span>
            <span className="apv2-summary-label">gisement d'eau grise collectable / an</span>
          </div>
        </div>
      </div>
      <div className="apv2-step-footer">
        <button type="button" className="apv2-footer-btn-ghost" onClick={goPrevious} disabled={currentStep === 0}>
          ← Précédent
        </button>
        <button type="button" className="apv2-footer-btn-cta" onClick={goNext} disabled={!canAdvance}>
          Suivant →
        </button>
      </div>
    </div>
  );
};

export default SourcesStep;
